export default "__VITE_ASSET__B$oUagFL__"